import { createSelector } from '@reduxjs/toolkit';

const loadingState = (state) => state.utils.loading;

// export const selectIsLoading = createSelector(loadingState, (loading) => loading.isLoading);
export const selectIsLoading = createSelector(loadingState, ({ loading }) => Object.keys(loading).some((key) => loading[key]));
export const selectLoadingConfig = createSelector(loadingState, (loading) => loading.config);
